import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class PetBreedService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/petBreeds`, options);
  }
}

export default PetBreedService;
